import { render, staticRenderFns } from "./ConfirmPage.vue?vue&type=template&id=3d9da20a&scoped=true&"
import script from "./ConfirmPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPage.vue?vue&type=style&index=0&id=3d9da20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9da20a",
  null
  
)

export default component.exports